<template>
  <div>
    <el-checkbox v-model="hideLabel" @change="handleChange" >Masquer le label</el-checkbox>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    }
  },
  data () {
    return {
      hideLabel: false
    }
  },
  watch:
  {
    value: {
      handler (value) {
        try {
          const data = JSON.parse(value)
          if (typeof data === 'object') {
            this.hideLabel = !!data.hideLabel
          }
        }
        catch (error) {
          this.setDefaultValues()
        }
      },
      immediate: true
    }
  },
  methods: {
    setDefaultValues () {
      this.hideLabel = false
    },
    handleChange () {
      const data = {
        hideLabel: this.hideLabel
      }
      this.$emit('input', JSON.stringify(data))
      this.$emit('change', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/config/Counter.vue